import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/webdev/customer-projects/lachner-fe/app/context/DebugContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/builds/webdev/customer-projects/lachner-fe/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/builds/webdev/customer-projects/lachner-fe/styles/globals.css");
